import React from 'react';
import 'date-fns';
import {FormControl, InputLabel, MenuItem, OutlinedInput, Select,} from '@material-ui/core';
import TagAutocomplete from './TagAutocomplete';
import FileMap from "../item-map/FileMap";

function ItemAttributesForm(props) {
  const { item, itemType, handleItemChange, keywordsList, peopleList, validations, classes } = props;

  return (
    <>
      <div className={classes.row}>
        <FormControl
          variant="outlined"
          fullWidth
          margin="none"
          required={itemType === "Upload"}
          error={itemType === "Upload" && validations.emotion && !item.emotion}
        >
          <InputLabel>Emotion</InputLabel>
          <Select
            value={item.emotion || ""}
            onChange={(e) => handleItemChange({...item, emotion: e.target.value})}
            input={<OutlinedInput margin='dense' label="Emotion" />}
          >
            <MenuItem value='Angry'>Angry</MenuItem>
            <MenuItem value='Annoyed'>Annoyed</MenuItem>
            <MenuItem value='Happy'>Happy</MenuItem>
            <MenuItem value='Neutral'>Neutral</MenuItem>
            <MenuItem value='Pleased'>Pleased</MenuItem>
            <MenuItem value='Sad'>Sad</MenuItem>
            <MenuItem value='Scared'>Scared</MenuItem>
            <MenuItem value='Surprised'>Surprised</MenuItem>
          </Select>
        </FormControl>
        <FormControl
          variant="outlined"
          fullWidth
          margin="none"
          required={itemType === "Upload"}
          error={itemType === "Upload" && validations.beme && !item.beme}
        >
          <InputLabel>Beme</InputLabel>
          <Select
            value={item.beme || ""}
            onChange={ (e) => handleItemChange({...item, beme: e.target.value}) }
            input={<OutlinedInput margin='dense' label="Beme" />}
          >
            <MenuItem value='Aspiration' >Aspiration</MenuItem>
            <MenuItem value='Attitude'>Attitude</MenuItem>
            <MenuItem value='Belief'>Belief</MenuItem>
            <MenuItem value='Feeling'>Feeling</MenuItem>
            <MenuItem value='Mannerism'>Mannerism</MenuItem>
            <MenuItem value='Personality'>Personality</MenuItem>
            <MenuItem value='Perspective' >Perspective</MenuItem>
            <MenuItem value='Recollection'>Recollection</MenuItem>
            <MenuItem value='Relationship' >Relationship</MenuItem>
            <MenuItem value='Skill'>Skill</MenuItem>
            <MenuItem value='Value'>Value</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className={classes.row}>
        <TagAutocomplete
          label="Keywords"
          margin="none"
          items={item.keywords}
          options={keywordsList}
          getOptionLabel={k => k.text}
          updateItems={(newVal) => handleItemChange({...item, keywords: newVal})}
        />
        <TagAutocomplete
          margin="none"
          label="People"
          items={item.people}
          options={peopleList}
          getOptionLabel={p => p.name}
          updateItems={(newVal) => handleItemChange({...item, people: newVal})}
        />
      </div>
      <div style={{display:"flex", flexWrap:"wrap", gap:"1rem"}}>
        <FileMap
          id="itemEditMap"
          isDraggable={true}
          updateLocation={(newValue) => {
            handleItemChange({...item, location: newValue})
          }}
          location={item.location}
        />
      </div>
    </>
  );
}

export default ItemAttributesForm;
